(function () {
    'use strict';

    var TRIGGER_PRODUCT_IDS = [
      15530139746691,  // RossoLuce (hoofdproduct)
      15845598396803,  // rossoluce-massaggio-quotidiano-del-cuoio-capelluto
      15836606726531,  // rossoluce-healthy-hair-optimizer
      15819094753667   // rossoluce-scalp-routine
    ];
    var GIFT_PRODUCT_HANDLE = 'densiluce';

    var giftVariantId = null;
    var syncing       = false;
    var syncTimeout   = null;

    function init() {
      fetch('/products/' + GIFT_PRODUCT_HANDLE + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          giftVariantId = product.variants[0].id;
          syncGift();
        })
        .catch(function (e) {
          console.warn('[mb-gift] Kan DensiLuce niet laden:', e);
        });
    }

    function scheduleSync() {
      clearTimeout(syncTimeout);
      syncTimeout = setTimeout(syncGift, 100);
    }

    function fetchCart() {
      return fetch('/cart.js', {
        headers: { 'Content-Type': 'application/json' }
      }).then(function (r) { return r.json(); });
    }

    function addGift() {
      syncing = true;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: giftVariantId, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () { refreshDrawer(); })
        .catch(function (e) { console.warn('[mb-gift] Add mislukt:', e); })
        .finally(function () { syncing = false; });
    }

    function removeGift(lineIndex) {
      syncing = true;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function () { refreshDrawer(); })
        .catch(function (e) { console.warn('[mb-gift] Remove mislukt:', e); })
        .finally(function () { syncing = false; });
    }

    function syncGift() {
      if (syncing || !giftVariantId) return;

      fetchCart().then(function (cart) {
        var hasTrigger = cart.items.some(function (item) {
          return TRIGGER_PRODUCT_IDS.some(function (id) {
            return String(item.product_id) === String(id);
          });
        });

        var giftLine = null;
        cart.items.forEach(function (item, i) {
          if (String(item.variant_id) === String(giftVariantId)) {
            giftLine = i + 1;
          }
        });

        if (hasTrigger && giftLine === null) {
          addGift();
        } else if (!hasTrigger && giftLine !== null) {
          removeGift(giftLine);
        }
      });
    }

    function refreshDrawer() {
      document.dispatchEvent(new CustomEvent('upcart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    var _fetch = window.fetch;
    window.fetch = function (url) {
      var result = _fetch.apply(this, arguments);
      if (!syncing) {
        var urlStr = typeof url === 'string' ? url : '';
        if (
          urlStr.indexOf('/cart/add') !== -1 ||
          urlStr.indexOf('/cart/change') !== -1 ||
          urlStr.indexOf('/cart/update') !== -1
        ) {
          result.then(function () { scheduleSync(); }).catch(function () {});
        }
      }
      return result;
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(init, { timeout: 2000 });
        } else {
          setTimeout(init, 200);
        }
      });
    } else {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(init, { timeout: 2000 });
      } else {
        setTimeout(init, 200);
      }
    }

  })();